import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FacilityService } from 'src/app/core/services/facility.service';
import { SessionBaseComponent } from './../../../../shared/components/session.base.component';
import { Component, Injector, OnInit } from '@angular/core';
import { isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { DatePipe } from '@angular/common';
import { AirwaysExpenseService } from '../../service/airways-expense.service';
import { CommonDataService } from 'src/app/core/services/common-data.service';
import { CommonService } from '../../service/common.service';
import { DropdownOptionsService } from 'src/app/core/services/dropdown-options.service';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';

@Component({
  selector: 'laas-airways-expense-setting-edit',
  templateUrl: './airways-expense-setting-edit.component.html',
  styleUrls: ['./airways-expense-setting-edit.component.scss']
})
export class AirwaysExpenseSettingEditComponent extends SessionBaseComponent implements OnInit {
  readonly permissionCode = PermissionConstants.ViewAirwaysExpenseSetting;
  currentLang: string = this.laasSetting.language;

  airwaysExpense: any;
  editForm: FormGroup;
  forwarderOptions: any[];
  feeTypeOptions: any[];
  currencyOptions: any[];
  statusOptions: any[];
  countryOptions: any[];
  iataAreaOptions: any[];
  submitted: boolean;

  constructor(
    injector: Injector,
    private facilityService: FacilityService,
    private commonDataService: CommonDataService,
    private commonService: CommonService,
    private dropdownOptionsService: DropdownOptionsService,
    private airwaysExpenseService: AirwaysExpenseService,
    private formBuilder: FormBuilder,
    private datePipe: DatePipe
  ) {
    super(injector);
    this.forwarderOptions = [];
    this.feeTypeOptions = [];
    this.currencyOptions = [];
    this.statusOptions = [];
    this.countryOptions = [];
    this.iataAreaOptions = [];
    this.submitted = false;
    this.airwaysExpense = {
      forwarder: '',
      feeType: '',
      currency: '',
      amount: '',
      fromCountry: '',
      toIataArea: '',
      remark: '',
      isActivated: '1',
      startDtTimeZone: '',
      endDtTimeZone: '',
      updateUser: ''
    };

    this.editForm = this.formBuilder.group({
      forwarder: ['', Validators.required],
      feeType: ['', Validators.required],
      currency: ['', Validators.required],
      amount: ['', Validators.required],
      fromCountry: ['', Validators.required],
      toIataArea: ['', Validators.required],
      remark: '',
      isActivated: '1',
      startDtTimeZone: ['', Validators.required],
      endDtTimeZone: ['', Validators.required],
      updateUser: ''
    });
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();
    const seqNo = this.routeStateService.getCurrent().data.seqNo;

    try{
      this.airwaysExpense = await this.airwaysExpenseService.getAirwaysExpenseDetail(seqNo);
      this.airwaysExpense.declarationDtTimeZone = this.datePipe.transform(this.airwaysExpense.declarationDt, "yyyy/MM/dd", this.laasSetting.facilityTimeZone);
      this.airwaysExpense.startDtTimeZone = this.datePipe.transform(this.airwaysExpense.startDt, "yyyy/MM/dd", this.laasSetting.facilityTimeZone);
      this.airwaysExpense.endDtTimeZone = this.datePipe.transform(this.airwaysExpense.endDt, "yyyy/MM/dd", this.laasSetting.facilityTimeZone);
    }catch (err: any) {
      console.log('get tariff rate occur error: ' + JSON.stringify(err));
    }

    this.facilityService.getForwarderOptions(this.airwaysExpense.facility).subscribe({
      next: result => {
        this.forwarderOptions = [...result].map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });
      }
    });

    this.commonDataService.getCodeConverter(this.laasSetting.language, 'DropdownList', 'RFQStatus').subscribe({
      next: result => {
        this.statusOptions = [...result].map((x: any) => {
          return {
            label: `${x.codeKey}-${x.codeDesc}`,
            value: x.codeKey,
          };
        });
        this.statusOptions.unshift({
          label: '請選擇',
          value: ''
        });
      }
    });

    this.commonService.getFeeType('Airways').subscribe({
      next: result => {
        this.feeTypeOptions = [...result].map((x: any) => {
          return {
            label: `${x.feeTypeCode}-${x.feeTypeName}`,
            value: x.feeTypeCode,
          };
        });
        this.feeTypeOptions.unshift({
          label: '請選擇',
          value: ''
        });
      }
    });

    this.commonService.getCurrencyOptions().subscribe({
      next: result => {
        this.currencyOptions = [...result].map((x: any) => {
          return {
            label: `${x.currency_code}-${x.currency_name}`,
            value: x.currency_code,
          };
        });
        this.currencyOptions.unshift({
          label: '請選擇',
          value: ''
        });
      }
    });

    this.dropdownOptionsService.getVCountryOptions().subscribe({
      next: result => {
        this.countryOptions = [...result].map((x: any) => {
          return {
            label: x.countryName,
            value: x.countryCode,
          };
        });
        this.countryOptions.unshift({
          label: '請選擇',
          value: ''
        });
      }
    });

    this.commonDataService.getCodeConverter(this.laasSetting.language, 'DropdownList', 'IATAArea').subscribe({
      next: result => {
        this.iataAreaOptions = [...result].map((x: any) => {
          return {
            label: `${x.codeKey}-${x.codeDesc}`,
            value: x.codeKey,
          };
        });
        this.iataAreaOptions.unshift({
          label: '請選擇',
          value: ''
        });
      }
    });

    //rbac to maintain this page
    var canInPage = this.permissionCodes.includes(this.permissionCode);
    if (!canInPage) {
      //go unAuthorize
      this.routeStateService.navigateTo('/Error/unAuthorize');
    }
  }

  saveBtnClick(event: any): void{
    if (this.editForm.invalid) {
      this.toastService.warn(this.translateService.instant('AirwaysExpenseSetting.Alert.CheckRequiredFields'));
      return;
    }

    //DateTime convert
    this.airwaysExpense.declarationDt = isNullOrEmpty(this.airwaysExpense.declarationDtTimeZone) ? null : new Date(this.airwaysExpense.declarationDtTimeZone).toISOString();
    this.airwaysExpense.startDt = isNullOrEmpty(this.airwaysExpense.startDtTimeZone) ? null : new Date(this.airwaysExpense.startDtTimeZone).toISOString();
    this.airwaysExpense.endDt = isNullOrEmpty(this.airwaysExpense.endDtTimeZone) ? null : new Date(this.airwaysExpense.endDtTimeZone).toISOString();
    this.airwaysExpense.updateUser = this.userProfile.userName;

    this.airwaysExpenseService.updateAirwaysExpense(this.airwaysExpense).subscribe({
      next: result => {
        this.translateService.get('Common.Message.SuccessSave')
            .subscribe({
              next: msg => {
                this.toastService.success(msg);
                this.routeStateService.navigateTo('/Setting/AirwaysExpenseSetting', this.airwaysExpense);
              }
            });
      }
    });
  }

  goToLastPage(): void{
    this.routeStateService.loadPrevious();
  }
}
